<template>
  <div class="stack-section-container">
    <div class="title f-r">
      <span class="content">{{ rowNo }}-{{ stackNo }}-{{ sectionNo }}</span>
    </div>
    <div class="f-r graph-container">
      <div
        class="stack-slot-graph"
        v-for="(slot, index) in sectionSlotData"
        :key="'slot' + index"
      >
        <span class="slotNo">{{ slot.slotNo }}</span>
      </div>
    </div>
    <basic-table
      class="stackSlotTable"
      :table-data="sectionSlotData"
      :table-headers="sectionSlotTableHeaders"
      :has-actions="false"
    >
      <!-- <template v-slot:row-actions="props">
        <el-popover
          trigger="hover"
          placement="top-start"
          @mouseenter.native="getSrc(props.row, props.index)"
        >
          <img :src="srcList[props.index]" />
          <el-button
            size="small"
            type="text"
            slot="reference"
            class="success-text"
            :style="{ marginLeft: '10px' }"
            >QR Code</el-button
          >
        </el-popover>
      </template> -->
    </basic-table>
  </div>
</template>
<script>
import BasicTable from '@/components/common/BasicTable.vue'

const QRCode = require('qrcode')

export default {
  namne: 'StackSection',
  props: {
    rowNo: {
      type: String,
      required: true
    },
    stackNo: {
      type: String,
      required: true
    },
    sectionNo: {
      type: String,
      required: true
    },
    sectionSlotData: {
      type: Array,
      default: () => []
    },
    sectionSlotTableHeaders: {
      type: Array,
      required: true
    }
  },
  components: {
    BasicTable
    // StackSlot
  },
  methods: {
    async getSrc(slot, index) {
      const src = await QRCode.toDataURL(
        JSON.stringify({
          type: 'slot',
          slotId: slot.id,
          slotNo: slot.no
        })
      )
      this.$set(this.srcList, index, src)
    }
  },
  watch: {
    sectionSlotData() {
      this.$set(this, 'srcList', Array(this.sectionSlotData.length))
    }
  },
  data() {
    return {
      srcList: []
    }
  },
  mounted() {}
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.stack-section-container {
  .title {
    gap: 20px;
    font-size: 32px;

    span {
      font-weight: bold;
      font-size: 48px;
    }

    margin-bottom: 10px;
  }

  .graph-container {
    gap: 10px;
    margin-bottom: 20px;

    .stack-slot-graph {
      background-color: $el-primary-color;
      flex-grow: 1;
      border-radius: 12px;
      height: 60px;
      position: relative;

      .slotNo {
        font-size: 40px;
        color: white;
        font-weight: bold;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }
}
</style>
